import { render, staticRenderFns } from "./VisualizaOrdemDeServico.vue?vue&type=template&id=6670b11b&scoped=true&"
import script from "./VisualizaOrdemDeServico.vue?vue&type=script&lang=js&"
export * from "./VisualizaOrdemDeServico.vue?vue&type=script&lang=js&"
import style0 from "./VisualizaOrdemDeServico.vue?vue&type=style&index=0&id=6670b11b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670b11b",
  null
  
)

export default component.exports